import { Outlet, createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { useEffect } from 'react';
import z from 'zod';

import { DEFAULT_PAGE_SIZE } from '@/components/BaseTable/BaseTable';
import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';
import { AdminTeams } from '@/components/Teams/AdminTeams';
import { useIsExactRouteMatch } from '@/hooks/useIsExactRouteMatch';
import { useUser } from '@/hooks/useUser';
import { searchParam } from '@/utils/router';
import { requiredSortingSearchParam } from '@/utils/tableSorting';

const teamsSearchSchema = z.object({
  tPageSize: fallback(z.number(), DEFAULT_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
  tPageIndex: fallback(z.number(), 0).default(0),
  tSearch: searchParam().optional(),
  tNew: fallback(z.boolean(), false).default(false),
  tSorting: requiredSortingSearchParam([{ id: 'name', desc: false }]),
});

export const Route = createFileRoute('/$organizationName/settings/_access/teams')({
  component: TeamsLayout,
  validateSearch: zodValidator(teamsSearchSchema),
});

function TeamsLayout() {
  const { organizationDisplayName } = useUser();
  const isExactMatch = useIsExactRouteMatch(Route.id);

  useEffect(() => {
    if (isExactMatch) {
      document.title = `${organizationDisplayName || 'Driver'} - Teams`;
    }
  }, [organizationDisplayName, isExactMatch]);

  return (
    <SettingsPageLayout fullWidthWithPadding hideSeparator>
      <AdminTeams />
      <Outlet />
    </SettingsPageLayout>
  );
}
